import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoService {

  path: string = '../../../assets/image/vdi/IMG/';

  constructor() { }

  getPeriodo() {
    return  [
      { clave: 'Enero', valor: "Enero" },
      { clave: 'Febrero', valor: "Febrero" },
      { clave: 'Marzo', valor: "Marzo" },
      { clave: 'Abril', valor: "Abril" },
      { clave: 'Mayo', valor: "Mayo" },
      { clave: 'Junio', valor: "Junio" },
      { clave: 'Julio', valor: "Julio" },
      { clave: 'Agosto', valor: "Agosto" },
      { clave: 'Septiembre', valor: "Septiembre" },
      { clave: 'Octubre', valor: "Octubre" },
      { clave: 'Noviembre', valor: "Noviembre" },
      { clave: 'Diciembre', valor: "Diciembre" }
    ];
  }

  getCatalogoOpciones() {
    // Img_Blanco(1), Img_Borrosa(2), Doc_Equivocado(3), Doc_Ok(4),
    // Sin_Doc(5), Revisado(6),
    return [
      { clave: 'Img_Blanco', valor: "Imagen en Blanco" },
      { clave: 'Img_Borrosa', valor: "Imagen Borrosa" },
      { clave: 'Doc_Equivocado', valor: "Documento Equivocado" },
      { clave: 'Doc_Ok', valor: "Documento Ok" },
      { clave: 'Sin_Doc', valor: "Sin Documento" },
      { clave: 'Revisado', valor: "Revisado" },
    ]
  }

  getCatalogoOpcionesRetencion() {
    //Todos(0), Si(1), No(2);
    return [
      { clave: 'Todos', valor: "Todos" },
      { clave: 'Si', valor: "Si" },
      { clave: 'No', valor: "No" },
    ]
  }

  getCatalogoStatusReteciones() {
    //Todos(0), Img_Blanco_Borrosa(1), Doc_Equivocado(2), Doc_Ok(3), Pendiente(99);
    return [
      { clave: 'Todos', valor: "Todos" },
      { clave: 'Img_Blanco_Borrosa', valor: "Imagen en Blanco/Borrosa"},
      { clave: 'Doc_Equivocado', valor: "Documento Equivocado" },
      { clave: 'Doc_Ok', valor: "Documento OK" },
      { clave: 'Pendiente', valor: "Pendiente" },
    ]
  }

  getCatalogoOpcionesStatusReteciones() {
    // Img_Blanco(1), Img_Borrosa(2), Doc_Equivocado(3), Doc_Ok(4),
    // Sin_Doc(5), Revisado(6),
    return [
      { clave: 'Img_Blanco_Borrosa', valor: "Imagen en Blanco/Borrosa" },
      { clave: 'Doc_Equivocado', valor: "Documento Equivocado" },
      { clave: 'Doc_Ok', valor: "Documento Ok" },
    ]
  }

  getCatalogoTipoDescarga(){
    //Retencion(0),Factura(1),Carga(2);
    return[
      {clave: 'Retencion', valor: 'Sólo Retenciones'},
      {clave: 'Factura', valor: 'Facturas (Documentos Relacionados)'},
      {clave: 'Carga', valor: 'Carga de Archivo'},
    ]
  }

  getCatalogoTipoArchivoDescarga(){
    //Retencion(0),Factura(1),Carga(2);
    return[
      {clave: 'Retencion', valor: 'Retencion'},
      {clave: 'Factura', valor: 'Factura'},
    ]
  }

  catalogoIcon(){
    return {
      empresa: this.path + 'empresa.svg',
      agencia: this.path + 'agencia.svg',
      periodo: this.path + 'periodo.svg',
      vendedor: this.path + 'aser.jpg',
      vendeorApoyo: this.path + 'user.png',
      cliente: this.path + 'client.png',
      calendario: this.path + 'calendario-svg.svg',
      fechaReg: this.path + 'calendario.png',
      checkOption: this.path + 'check-mark.png',
      fechaCalendario: this.path + 'calendario-semanal.png',
    };
  }

}
